import React from 'react';
import Search from './components/Search';
import CreateBtn from './components/CreateBtn';
import ClientTypeMultipleSelect from './components/ClientTypeMultipleSelect';
import { StatusSelect } from './components/StatusSelect';
import ResetBtn from './components/ResetBtn';
import SortBy from './components/SortBy/SortBy';
import CountOfItem from './components/CountOfItem';
import CountrySelect from './components/CountrySelect';
import CitySelect from './components/CitySelect';
import CustomerSelect from './components/CustomerSelect';
import WithURLFilters from './components/WithURLFilters';
import style from './RestaurantsControlPanel.module.scss';

const RestaurantsControlPanel: React.FC = () => {
	return (
		<WithURLFilters>
			<div className={style.firstRowWithControls}>
				<Search />
				<CreateBtn />
			</div>
			<div className={style.secondRowWithControls}>
				<div className={style.selectWrapper}>
					<CountrySelect />
					<CitySelect />
					<CustomerSelect />
					<ClientTypeMultipleSelect />
					<StatusSelect />
				</div>
				<div className={style.verticalAlignBlock}>
					<ResetBtn />
					<SortBy />
					<CountOfItem />
				</div>
			</div>
		</WithURLFilters>
	);
};

export default RestaurantsControlPanel;
